import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LoaderService } from '@shared/services/loader.service';
import { DialogService } from '../../services/dialog.service';
import { UserService } from '../../services/user-service.service';
import { UserActionComponent } from '../user-actions/user-action.component';

@Component({
	selector: 'app-header',
	templateUrl: 'header.component.html',
	styleUrls: ['header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {

	public user$ = this.userService.user$;

	@ViewChild('userActions', { static: false }) private userActionsElement: ElementRef;

	constructor(
		private userService: UserService,
		private dialogService: DialogService,
		private loaderService: LoaderService
	) { }

	public ngOnInit(): void {
		this.loaderService.margin$.next(true);
	}

	public openUserActionsDialog(): void {
		this.dialogService.show(UserActionComponent, {
			positionRelativeToElement: this.userActionsElement,
			authorizedUser: this.userService.isLoggedIn(),
			hasBackdrop: true,
			height: this.userService.isLoggedIn() ? '140px' : '327px',
			width: '270px',
			panelClass: 'login-dialog-container'
		});
	}

	public ngOnDestroy(): void {
		this.loaderService.margin$.next(false);
	}

}
